export interface AuthState {
    authenticated: boolean;
    sessionToken: string;
    userId: string;
    errorMessage: string;
    isGoogleAccount: boolean;
    didSignUp: boolean;
}

const defaultState: AuthState = {
    authenticated: false,
    sessionToken: "",
    userId: "",
    errorMessage: "",
    isGoogleAccount: false,
    didSignUp: false
};

export default defaultState;
